import { render, staticRenderFns } from "./GroupStageTable.vue?vue&type=template&id=0a567ff5&scoped=true"
import script from "./GroupStageTable.vue?vue&type=script&lang=js"
export * from "./GroupStageTable.vue?vue&type=script&lang=js"
import style0 from "./GroupStageTable.vue?vue&type=style&index=0&id=0a567ff5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a567ff5",
  null
  
)

export default component.exports